module.exports = __webpack_public_path__ + "static/media/sTrBuy.8313291c.png";